import { useLayoutEffect, useState } from 'react';
import { isMobile } from 'tradera-utils/breakpoints';

export function useBreakpointMobile() {
    const [active, setActive] = useState(isMobile(window.innerWidth));
    useLayoutEffect(() => {
        const handleResize = event =>
            setActive(isMobile(event.target.innerWidth));
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    });
    return active;
}
